export function replaceBreaks(text) {
  if (!text) return;
  return text.replace(/\<br\>/g, " ");
}

export function stripHtml(html) {
  const replaceCommonCharsConfig = {
    [String.fromCharCode(160)]: String.fromCharCode(32),
  };

  const replaceCommonChars = (str) =>
    Object.entries(replaceCommonCharsConfig).reduce(
      (curStr, [searchChar, replaceChar]) =>
        curStr.replaceAll(searchChar, replaceChar),
      str
    );

  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;

  return replaceCommonChars(tmp.textContent || tmp.innerText || "");
}

export function goToIndexPage(){
  window.history.replaceState({page: "index"}, "index page", "index");
}

// Utility function to format a date string into 'Day, Month DD, YYYY'
export function formatDateWithDay(dateString) {
    const date = new Date(dateString);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

export function getFileIcon(fileName) {
  const faIcons = {
    image: "file-image",
    pdf: "file-pdf",
    word: "file-word",
    powerpoint: "file-powerpoint",
    excel: "file-excel",
    csv: "file-csv",
    audio: "file-audio",
    video: "file-video",
    archive: "file-archive",
    code: "file-code",
    text: "file-lines",
    file: "file",
  };

  const fileExtensions = {
    gif: faIcons.image,
    jpeg: faIcons.image,
    jpg: faIcons.image,
    png: faIcons.image,
    tiff: faIcons.image,
    tif: faIcons.image,
    bmp: faIcons.image,

    pdf: faIcons.pdf,

    doc: faIcons.word,
    docx: faIcons.word,

    ppt: faIcons.powerpoint,
    pptx: faIcons.powerpoint,

    xls: faIcons.excel,
    xlsx: faIcons.excel,

    csv: faIcons.csv,

    aac: faIcons.audio,
    mp3: faIcons.audio,
    ogg: faIcons.audio,

    avi: faIcons.video,
    flv: faIcons.video,
    mkv: faIcons.video,
    mp4: faIcons.video,

    gz: faIcons.archive,
    zip: faIcons.archive,

    css: faIcons.code,
    html: faIcons.code,
    js: faIcons.code,

    txt: faIcons.text,
  };

  // safer extraction
  const ext = fileName?.includes(".")
    ? fileName.split(".").pop().toLowerCase()
    : "";

  const iconName = fileExtensions[ext] || faIcons.file;

  return ["fas", iconName];
}

export function sendAnalyticsData(data) {
    var isPreAuth = true;
    if(data && data.userName){
      isPreAuth = false;
    }
    setTimeout(() => {
      let docTittle = (document.title).split("-");
      const clientName = docTittle[0]; 
      const pageTittle = docTittle[1]; 
      let currentDate  = new Date();
      window.diAnalyticsObj = {
          /*clientId:"$client",
          clientName:CLIENT_TITLE,*/
          clientId: clientName,
          pageId: pageTittle,
          clientName: clientName,
          userTimeZone:(String(String(currentDate).split("(")[1]).split(")")[0]),
          localTime:currentDate.toLocaleTimeString('en-IT', { hour12: false }),
          localDate:currentDate.toLocaleDateString(),
          browser:window.navigator.userAgent,
          platform:window.navigator.platform
      };
      if(!isPreAuth){
        if(data != undefined){
          window.diAnalyticsObj.userId = data.userName;
          if(data.age != null){
            window.diAnalyticsObj.age = (data.age).toString();
          }
          window.diAnalyticsObj.ma_id = data.maId;
        }
      }
      if(data && data.errorCode != null){
        window.diAnalyticsObj.errorCode = data.errorCode;
      }
      if(RESOURSE_PROPERTIES.adobeAnalyticsEnabled){
        var event = new CustomEvent(
        "PageChangeEvent",
        {
          bubbles:true,
          cancelable:true,
          detail:JSON.parse(JSON.stringify(diAnalyticsObj))
        });
        dispatchEvent(event);
      }
      if(RESOURSE_PROPERTIES.adobeAnalyticswebSDKEnabled) {
        window.adobeDataLayer.push({"event":"ctaPageView","data":JSON.parse(JSON.stringify(diAnalyticsObj))})   
      }
        
    }, 500);
  }
